// Telas ainda não implementadas mostram o que virá — mantém o mapa do
// produto visível (o protótipo é o contrato visual).
export function Placeholder({ title, note }: { title: string; note: string }) {
  return (
    <div style={{ position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 10, padding: 24, textAlign: 'center' }}>
      <div style={{ width: 38, height: 38, borderRadius: '50%', border: '1.5px dashed var(--border-2)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text-3)', fontSize: 16 }}>∅</div>
      <div style={{ font: '600 14px/1.2 var(--font-sans)', color: 'var(--text-2)' }}>{title}</div>
      <div style={{ font: '400 11.5px/1.5 var(--font-mono)', color: 'var(--text-3)', maxWidth: 420 }}>{note}</div>
    </div>
  )
}
